<ng-container *ngIf="!isTemplate; else templateView">
  <!-- <ng-container> -->
  <div class="branches">
    <div class="header">
      <h1 i18n="@@branches.header.my_branches">My branches</h1>
      <div class="controls" *ngIf="basicInfo?.user_type == 'super_admin' && !basicInfo?.foodics_available">
        <button class="edit-tpl" (click)="showTemplate()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 10.0001L14 6.00006M2.5 21.5001L5.88437 21.124C6.29786 21.0781 6.5046 21.0551 6.69785 20.9925C6.86929 20.937 7.03245 20.8586 7.18289 20.7594C7.35245 20.6476 7.49955 20.5005 7.79373 20.2063L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8955 1.89549 18.1046 1.89549 17 3.00006L3.79373 16.2063C3.49955 16.5005 3.35246 16.6476 3.24064 16.8172C3.14143 16.9676 3.06301 17.1308 3.00751 17.3022C2.94496 17.4955 2.92198 17.7022 2.87604 18.1157L2.5 21.5001Z"
              stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span i18n="@@branches.header.edit_template">Edit template</span>
        </button>
        <button *ngIf="branches.length > 0" class="create-branch" (click)="editBranch()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span i18n="@@branches.header.create_branch">Create new branch</span>
        </button>
      </div>
      <div class="controls" *ngIf="branches?.length > 0 && basicInfo?.foodics_available">
        <button class="create-branch" (click)="fetchFoodicsBranches()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span i18n="@@branches.header.fetch_branch">Fetch foodics branch</span>
        </button>
      </div>
    </div>
    <div class="branch-grid" *ngIf="branches?.length > 0">
      <div class="branch-card" *ngFor="let branch of branches; let i = index">
        <div class="branch-img">
          <img [src]="branch.img" loading="lazy" [ngClass]="{ 'illustration': true, 'innactive': !branch.storeFrontShow }"
            alt="{{ branch.title }}" />
          <button class="branch-actions" (click)="toggleActionDropdown(i)">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75Z"
                stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M9 4.5C9.41421 4.5 9.75 4.16421 9.75 3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75C8.25 4.16421 8.58579 4.5 9 4.5Z"
                stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M9 15C9.41421 15 9.75 14.6642 9.75 14.25C9.75 13.8358 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.8358 8.25 14.25C8.25 14.6642 8.58579 15 9 15Z"
                stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <div class="dropdown-menu" *ngIf="activeDropdownIndex === i">
            <button class="dropdown-item" (click)="editBranch(branch.id)"
              i18n="@@branches.branch_card.edit">Edit</button>
            <button class="dropdown-item delete" (click)="deleteBranch(branch)"
              i18n="@@branches.branch_card.delete">Delete</button>
          </div>
        </div>
        <h2>{{ branch.title }}</h2>
        <p class="branch-location">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
              stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
              stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <ng-container>{{ branch.location }}</ng-container>
        </p>
        <div class="branch-row">
          {{ branch.url }}
          <button class="copy-buffer" (click)="copyToClipboard(branch.url)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z"
                stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="branch-row">
          <p i18n="@@branches.branch_card.show_on_storefront">Show on global storefront</p>
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="branch.storeFrontShow" (change)="toggleBranchStatus(branch)" />
            <span class="slider"></span>
          </label>
        </div>
        <button class="branch-link"  (click)="goto(branch.url)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C3.98825 13.6503 5.24331 15.0407 6.80248 16.0133C8.36165 16.9858 10.1624 17.5013 12 17.5013C13.8376 17.5013 15.6383 16.9858 17.1975 16.0133C18.7567 15.0407 20.0117 13.6503 20.82 12C20.0117 10.3497 18.7567 8.95925 17.1975 7.98675C15.6383 7.01424 13.8376 6.49868 12 6.49868C10.1624 6.49868 8.36165 7.01424 6.80248 7.98675C5.24331 8.95925 3.98825 10.3497 3.18 12Z"
              fill="#EB1461" />
          </svg>
          <ng-container i18n="@@branches.branch_card.visit">Visit</ng-container>
        </button>
      </div>
    </div>

    <div class="empty" *ngIf="!branches?.length && !basicInfo?.foodics_available">
      <div class="empty-wrapper">
        <img src="images/store-branches/empty_state.svg" alt="emtpy">
        <h2 i18n="@@branches.empty_state.add_first_branch" *ngIf="basicInfo?.user_type != 'user'">Add your first branch</h2>
        <h2 i18n="@@branches.empty_state.no_branch" *ngIf="basicInfo?.user_type == 'user'">No branch found!</h2>
        <div class="empty-actions" *ngIf="basicInfo?.user_type != 'user'">
          <button class="skip" i18n="@@branches.empty_state.skip_for_now">Skip for now</button>
          <button class="create-branch" (click)="editBranch()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span i18n="@@branches.header.create_branch">Create new branch</span>
          </button>
        </div>
      </div>
    </div>
    <div class="empty" *ngIf="!branches?.length && basicInfo?.foodics_available">
      <div class="empty-wrapper">
        <img src="images/store-branches/empty_state.svg" alt="emtpy">
        <h2 i18n="@@branches.empty_state.add_first_branch" *ngIf="basicInfo?.user_type != 'user'">Fetch your foodics branch</h2>
        <h2 i18n="@@branches.empty_state.no_branch" *ngIf="basicInfo?.user_type == 'user'">No branch found!</h2>
        <div class="empty-actions" *ngIf="basicInfo?.user_type != 'user'">
          <!-- <button class="skip" i18n="@@branches.empty_state.skip_for_now">Skip for now</button> -->
          <button class="create-branch" (click)="fetchFoodicsBranches()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span i18n="@@branches.header.create_branch">Fetch Foodics branch</span>
          </button>
        </div>
      </div>
    </div>
    <app-create-new-branch *ngIf="isOpen" (close)="closeCreateBranchModal()" [branchData]="branchData" [isTemplateData]="isTemplateData" [basicInfo]="basicInfo"></app-create-new-branch>
  </div>
</ng-container>
<ng-template #templateView>
  <app-branch-template [myStoreType]="storeType"
    (onBusinessTypeChange)="businessTypeChange($event)" *ngIf="isTemplate"
    (hideTemplate)="hideTemplate()"></app-branch-template>
</ng-template>